var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spec-stock-form" }, [
    !_vm.hideSpecTypeSelector
      ? _c(
          "div",
          { staticClass: "spec-type-selector" },
          [
            _c(
              "el-radio-group",
              {
                attrs: {
                  disabled: !!_vm.id || _vm.isWmTg === 2 || _vm.isWmTg === 3,
                },
                on: { change: _vm.handleattrTypeChange },
                model: {
                  value: _vm.attrType,
                  callback: function ($$v) {
                    _vm.attrType = $$v
                  },
                  expression: "attrType",
                },
              },
              [
                _c(
                  "el-radio-button",
                  {
                    attrs: {
                      label: "single",
                      disabled:
                        !!_vm.id || _vm.isWmTg === 2 || _vm.isWmTg === 3,
                    },
                  },
                  [_vm._v("单规格")]
                ),
                _vm._v(" "),
                _c(
                  "el-radio-button",
                  {
                    attrs: {
                      label: "multi",
                      disabled:
                        !!_vm.id || _vm.isWmTg === 2 || _vm.isWmTg === 3,
                    },
                  },
                  [_vm._v("多规格（无库存）\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "el-radio-button",
                  {
                    attrs: {
                      label: "sku",
                      disabled:
                        !!_vm.id || _vm.isWmTg === 2 || _vm.isWmTg === 3,
                    },
                  },
                  [_vm._v("sku（库存）")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            !!_vm.id
              ? _c(
                  "div",
                  { staticClass: "edit-mode-tip" },
                  [
                    _c("el-alert", {
                      attrs: {
                        title: "编辑模式下不可更改商品规格类型",
                        type: "info",
                        closable: false,
                        "show-icon": "",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.attrType === "single" && !_vm.hideDateModeStockFields
      ? _c(
          "div",
          { staticClass: "single-spec" },
          [
            _c(
              "el-form",
              {
                ref: "singleSpecRef",
                attrs: {
                  model: _vm.singleSpecForm,
                  rules: _vm.dynamicSingleSpecRules,
                  "label-width": "120px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "售价：", prop: "price" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                maxlength: "6",
                                min: "0",
                                oninput:
                                  "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                              },
                              model: {
                                value: _vm.singleSpecForm.price,
                                callback: function ($$v) {
                                  _vm.$set(_vm.singleSpecForm, "price", $$v)
                                },
                                expression: "singleSpecForm.price",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "原价：", prop: "otPrice" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                maxlength: "6",
                                min: "0",
                                oninput:
                                  "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                              },
                              model: {
                                value: _vm.singleSpecForm.otPrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.singleSpecForm, "otPrice", $$v)
                                },
                                expression: "singleSpecForm.otPrice",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "成本价：", prop: "costPrice" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                maxlength: "6",
                                min: "0",
                                oninput:
                                  "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                              },
                              model: {
                                value: _vm.singleSpecForm.costPrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.singleSpecForm, "costPrice", $$v)
                                },
                                expression: "singleSpecForm.costPrice",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    !_vm.hideDateModeStockFields
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "库存：", prop: "stock" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    maxlength: "6",
                                    type: "number",
                                    min: "0",
                                    oninput:
                                      "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                                  },
                                  model: {
                                    value: _vm.singleSpecForm.stock,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.singleSpecForm, "stock", $$v)
                                    },
                                    expression: "singleSpecForm.stock",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideDateModeStockFields
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "库存预警：",
                                  prop: "stockWarning",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    maxlength: "6",
                                    type: "number",
                                    min: "0",
                                    oninput:
                                      "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                                  },
                                  model: {
                                    value: _vm.singleSpecForm.stockWarning,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleSpecForm,
                                        "stockWarning",
                                        $$v
                                      )
                                    },
                                    expression: "singleSpecForm.stockWarning",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showBarCodeField
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "条形码", prop: "barCode" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: _vm.singleSpecForm.barCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleSpecForm,
                                        "barCode",
                                        $$v
                                      )
                                    },
                                    expression: "singleSpecForm.barCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "起购数量：", prop: "minQuantity" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                maxlength: "6",
                                type: "number",
                                min: "1",
                                oninput:
                                  "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                              },
                              model: {
                                value: _vm.singleSpecForm.minQuantity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.singleSpecForm,
                                    "minQuantity",
                                    $$v
                                  )
                                },
                                expression: "singleSpecForm.minQuantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "限购：", prop: "maxQuantity" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                maxlength: "6",
                                type: "number",
                                min: "0",
                                oninput:
                                  "if(value.length>6)value=value.slice(0,6);value=value.replace(/^0+(?=\\d)/,'');if(parseFloat(value)<0||value.indexOf('-')!==-1)value=''",
                              },
                              model: {
                                value: _vm.singleSpecForm.maxQuantity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.singleSpecForm,
                                    "maxQuantity",
                                    $$v
                                  )
                                },
                                expression: "singleSpecForm.maxQuantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "SKU编码：", prop: "skuCode" } },
                          [
                            _c("el-input", {
                              staticClass: "form-width",
                              attrs: {
                                placeholder: "自动生成或手动填写，不可重复",
                                disabled: "",
                              },
                              model: {
                                value: _vm.singleSpecForm.skuCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.singleSpecForm, "skuCode", $$v)
                                },
                                expression: "singleSpecForm.skuCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isWmTg === 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "重量(kg)：", prop: "weight" },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: _vm.singleSpecForm.weight,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleSpecForm,
                                        "weight",
                                        $$v
                                      )
                                    },
                                    expression: "singleSpecForm.weight",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-alert", {
                                  staticStyle: {
                                    "margin-top": "9px",
                                    "white-space": "normal",
                                    "line-height": "18px",
                                  },
                                  attrs: {
                                    closable: false,
                                    title:
                                      "请填写商品重量.若未填写,则默认商品只有首重无续重",
                                    type: "warning",
                                    "show-icon": "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWmTg === 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "体积(m³)：", prop: "volume" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      gap: "8px",
                                    },
                                  },
                                  [
                                    _c("span", [_vm._v("长")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入(m)" },
                                      model: {
                                        value: _vm.singleSpecForm.volumeLong,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.singleSpecForm,
                                            "volumeLong",
                                            $$v
                                          )
                                        },
                                        expression: "singleSpecForm.volumeLong",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("宽")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入(m)" },
                                      model: {
                                        value: _vm.singleSpecForm.volumeWide,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.singleSpecForm,
                                            "volumeWide",
                                            $$v
                                          )
                                        },
                                        expression: "singleSpecForm.volumeWide",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("高")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入(m)" },
                                      model: {
                                        value: _vm.singleSpecForm.volumeHigh,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.singleSpecForm,
                                            "volumeHigh",
                                            $$v
                                          )
                                        },
                                        expression: "singleSpecForm.volumeHigh",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span"),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.attrType === "multi"
      ? _c("div", { staticClass: "multi-spec" }, [
          _c(
            "div",
            { staticClass: "spec-selector" },
            [
              _c(
                "div",
                { staticClass: "selector-row" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("选择规格：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "rule-select",
                      attrs: {
                        placeholder: "请选择规格类型",
                        disabled: !!_vm.id,
                      },
                      model: {
                        value: _vm.selectedRuleType,
                        callback: function ($$v) {
                          _vm.selectedRuleType = $$v
                        },
                        expression: "selectedRuleType",
                      },
                    },
                    _vm._l(_vm.rulesList, function (rule) {
                      return _c("el-option", {
                        key: rule.id,
                        attrs: { label: rule.ruleName, value: rule.id },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: !!_vm.id,
                      },
                      on: { click: _vm.confirmAddRule },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.addNewRule },
                    },
                    [_vm._v("添加规格")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.editableRules, function (rule) {
                return _c(
                  "div",
                  { key: rule.id, staticClass: "spec-group-container" },
                  [
                    _c("div", { staticClass: "spec-group-header" }, [
                      _c("div", { staticClass: "spec-name" }, [
                        _vm._v(
                          "规格：" + _vm._s(rule.attrName || rule.ruleName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "header-actions" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                "true-label": rule.attrName,
                                "false-label": null,
                                disabled:
                                  _vm.includeWeightRuleName !== null &&
                                  _vm.includeWeightRuleName !== rule.attrName,
                              },
                              model: {
                                value: _vm.includeWeightRuleName,
                                callback: function ($$v) {
                                  _vm.includeWeightRuleName = $$v
                                },
                                expression: "includeWeightRuleName",
                              },
                            },
                            [
                              _vm._v(
                                "\n              包含重量体积参数\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addRuleValue(
                                    rule.attrCode !== undefined
                                      ? rule.attrCode
                                      : rule.id
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              添加规格值\n            ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "spec-values-table" },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "spec-table",
                            attrs: {
                              data: _vm.getSpecValueTableData(rule),
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "默认选择",
                                width: "120",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: scope.$index,
                                              disabled: scope.row.status === 0,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleDefaultValueChange(
                                                  rule,
                                                  scope.$index
                                                )
                                              },
                                            },
                                            model: {
                                              value: rule.valueCode,
                                              callback: function ($$v) {
                                                _vm.$set(rule, "valueCode", $$v)
                                              },
                                              expression: "rule.valueCode",
                                            },
                                          },
                                          [_c("span")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "规格值",
                                width: "120",
                                prop: "valueName",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { width: "120" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "如置空为0元",
                                              type: "number",
                                              required: "",
                                            },
                                            on: {
                                              input: _vm.handlePriceChange,
                                            },
                                            model: {
                                              value: scope.row.price,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "price",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.price",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("售价")]),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "原价", width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "如置空为0元",
                                            type: "number",
                                            required: "",
                                          },
                                          on: { input: _vm.handlePriceChange },
                                          model: {
                                            value: scope.row.otPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "otPrice",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.otPrice",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: { width: "120" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "请输入成本价",
                                              type: "number",
                                              required: "",
                                            },
                                            on: {
                                              input: _vm.handlePriceChange,
                                            },
                                            model: {
                                              value: scope.row.costPrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "costPrice",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.costPrice",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("成本价")]),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.includeWeightRuleName === rule.attrName
                              ? _c("el-table-column", {
                                  attrs: { label: "重量（kg）", width: "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                size: "mini",
                                                placeholder: "如置空为0kg",
                                                type: "number",
                                                required: "",
                                              },
                                              model: {
                                                value: scope.row.weight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "weight",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.weight",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.includeWeightRuleName === rule.attrName
                              ? _c("el-table-column", {
                                  attrs: { label: "长（m）", width: "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                size: "mini",
                                                placeholder: "如置空为0m",
                                                type: "number",
                                                required: "",
                                              },
                                              model: {
                                                value: scope.row.volumeLong,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "volumeLong",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.volumeLong",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.includeWeightRuleName === rule.attrName
                              ? _c("el-table-column", {
                                  attrs: { label: "宽（m）", width: "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                size: "mini",
                                                placeholder: "如置空为0m",
                                                type: "number",
                                                required: "",
                                              },
                                              model: {
                                                value: scope.row.volumeWide,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "volumeWide",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.volumeWide",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.includeWeightRuleName === rule.attrName
                              ? _c("el-table-column", {
                                  attrs: { label: "高（m）", width: "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                size: "mini",
                                                placeholder: "如置空为0m",
                                                type: "number",
                                                required: "",
                                              },
                                              model: {
                                                value: scope.row.volumeHigh,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "volumeHigh",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.volumeHigh",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "状态",
                                width: "100",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-switch", {
                                          attrs: {
                                            "active-text": "开启",
                                            "inactive-text": "关闭",
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          on: {
                                            change: function (val) {
                                              return _vm.handleStatusChange(
                                                rule,
                                                scope.$index,
                                                val
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.status,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "status", $$v)
                                            },
                                            expression: "scope.row.status",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                width: "80",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeRuleValue(
                                                  rule.attrCode !== undefined
                                                    ? rule.attrCode
                                                    : rule.id,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  删除\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-spec-action" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showAddSpecDialog },
                    },
                    [_vm._v("添加规格")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.multipleAttr.length > 0
                ? _c("div", { staticClass: "spec-info-display" }, [
                    _c("div", { staticClass: "spec-info-row" }, [
                      _c("span", { staticClass: "spec-info-label" }, [
                        _vm._v("默认规格："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "spec-info-value" }, [
                        _vm._v(_vm._s(_vm.getDefaultSpecsDisplay())),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "spec-info-row" }, [
                      _c("span", { staticClass: "spec-info-label" }, [
                        _vm._v("价格："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "spec-info-value" }, [
                        _vm._v(_vm._s(_vm.getTotalPriceDisplay()) + "元起"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.attrType === "sku"
      ? _c("div", { staticClass: "sku-spec" }, [
          _c(
            "div",
            { staticClass: "spec-selector" },
            [
              _c(
                "div",
                { staticClass: "selector-row" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("选择规格：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "rule-select",
                      attrs: {
                        placeholder: "请选择规格类型",
                        disabled: !!_vm.id,
                      },
                      model: {
                        value: _vm.selectedRuleType,
                        callback: function ($$v) {
                          _vm.selectedRuleType = $$v
                        },
                        expression: "selectedRuleType",
                      },
                    },
                    _vm._l(_vm.rulesList, function (rule) {
                      return _c("el-option", {
                        key: rule.id,
                        attrs: { label: rule.ruleName, value: rule.id },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: !!_vm.id,
                      },
                      on: { click: _vm.confirmAddRule },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: !!_vm.id,
                      },
                      on: { click: _vm.showAddSpecDialog },
                    },
                    [_vm._v("添加规格")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.selectedRules, function (rule) {
                return _c(
                  "div",
                  { key: rule.id, staticClass: "rule-display-group" },
                  [
                    _c("div", { staticClass: "rule-row" }, [
                      _c(
                        "div",
                        { staticClass: "rule-name-section" },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "rule-name-tag",
                              attrs: {
                                size: "small",
                                closable: !_vm.isEditMode,
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.removeRule(
                                    rule.attrCode !== undefined
                                      ? rule.attrCode
                                      : rule.id
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(rule.attrName || rule.ruleName) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "rule-values-section" },
                        [
                          _vm._l(rule.attrValues, function (value, index) {
                            return _c(
                              "el-tag",
                              {
                                key: index,
                                staticClass: "rule-value-tag",
                                attrs: {
                                  closable: !_vm.isEditMode,
                                  size: "small",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeRuleValue(
                                      rule.attrCode !== undefined
                                        ? rule.attrCode
                                        : rule.id,
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(value.valueName) +
                                    "\n          "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "add-value-btn",
                              attrs: {
                                size: "mini",
                                type: "text",
                                disabled: !!_vm.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addRuleValue(
                                    rule.attrCode !== undefined
                                      ? rule.attrCode
                                      : rule.id
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              + 添加\n            ")]
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.selectedRules.length > 0
                ? _c(
                    "div",
                    { staticClass: "bulk-data-container" },
                    [
                      _c("h3", { staticClass: "section-title" }, [
                        _vm._v("批量设置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "bulk-data-table",
                          attrs: {
                            data: [_vm.bulkDataForm],
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "规格图片",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "sku-image-uploader",
                                          on: {
                                            click: function ($event) {
                                              return _vm.uploadBulkImage(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          scope.row.image
                                            ? _c("img", {
                                                staticClass: "sku-image",
                                                attrs: { src: scope.row.image },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "sku-image-placeholder",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "upload-text",
                                                    },
                                                    [_vm._v("上传")]
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1984098251
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "120", align: "center" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "规格名称",
                                          },
                                          model: {
                                            value: scope.row.specName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "specName",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.specName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3269920471
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("规格名称")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "原价", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入原价",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.otPrice,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "otPrice", $$v)
                                          },
                                          expression: "scope.row.otPrice",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3353599074
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请输入售价",
                                            type: "number",
                                          },
                                          model: {
                                            value: scope.row.price,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "price", $$v)
                                            },
                                            expression: "scope.row.price",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2040090696
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("售价")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "成本价", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入成本价",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.costPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "costPrice",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.costPrice",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              448722065
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            { attrs: { label: "sku编码", width: "120" } },
                            [[_c("span", [_vm._v("自动生成")])]],
                            2
                          ),
                          _vm._v(" "),
                          _vm.showBarCodeField
                            ? _c("el-table-column", {
                                attrs: { label: "商品条码", width: "160" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "请输入商品条码",
                                            },
                                            model: {
                                              value: scope.row.barCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "barCode",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.barCode",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1307621386
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请输入库存",
                                            type: "number",
                                          },
                                          model: {
                                            value: scope.row.stock,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "stock", $$v)
                                            },
                                            expression: "scope.row.stock",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3231959127
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("库存")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "库存预警", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入预警值",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.stockWarning,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "stockWarning",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.stockWarning",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              96303176
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "起购量", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入起购量",
                                          type: "number",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.validateSkuQuantityRange(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.minQuantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "minQuantity",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.minQuantity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              621844303
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "限购", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入限购量",
                                          type: "number",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.validateSkuQuantityRange(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.maxQuantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "maxQuantity",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.maxQuantity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3780056310
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "重量(kg)", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入重量",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.weight,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "weight", $$v)
                                          },
                                          expression: "scope.row.weight",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              578959134
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "长(m)", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入长",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.volumeLong,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeLong",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeLong",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2218796289
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "宽(m)", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入宽",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.volumeWide,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeWide",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeWide",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3477543030
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "高(m)", width: "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入高",
                                          type: "number",
                                        },
                                        model: {
                                          value: scope.row.volumeHigh,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeHigh",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeHigh",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              978135746
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "上下架状态",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": "上架",
                                          "inactive-text": "下架",
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        model: {
                                          value: scope.row.status,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "status", $$v)
                                          },
                                          expression: "scope.row.status",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              297954310
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: "操作",
                                width: "120",
                                align: "center",
                                fixed: "right",
                              },
                            },
                            [
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: { click: _vm.applyBulkData },
                                  },
                                  [
                                    _vm._v(
                                      "\n                批量添加\n              "
                                    ),
                                  ]
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.skuCombinations.length > 0
                ? _c(
                    "div",
                    { staticClass: "sku-combinations-container" },
                    [
                      _c("h3", { staticClass: "section-title" }, [
                        _vm._v("规格组合"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          key: "sku-table-" + _vm.skuCombinations.length,
                          staticClass: "sku-table",
                          attrs: {
                            data: _vm.skuCombinations,
                            "max-height": "400",
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "选择",
                              width: "60",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: scope.$index },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleSkuSelect(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.selectedSkuIndex,
                                            callback: function ($$v) {
                                              _vm.selectedSkuIndex = $$v
                                            },
                                            expression: "selectedSkuIndex",
                                          },
                                        },
                                        [_c("span")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2406270641
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "规格图片",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "sku-image-uploader",
                                          on: {
                                            click: function ($event) {
                                              return _vm.uploadSkuImage(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          scope.row.image
                                            ? _c("img", {
                                                staticClass: "sku-image",
                                                attrs: { src: scope.row.image },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "sku-image-placeholder",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "upload-text",
                                                    },
                                                    [_vm._v("上传")]
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2312741494
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "150" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请输入规格名称",
                                          },
                                          model: {
                                            value: scope.row.skuName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "skuName",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.skuName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                564044670
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("规格名称")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "原价", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入原价",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.otPrice,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "otPrice", $$v)
                                          },
                                          expression: "scope.row.otPrice",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2814937036
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请输入售价",
                                            type: "number",
                                            min: "0",
                                          },
                                          on: { input: _vm.handleNumberInput },
                                          model: {
                                            value: scope.row.price,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "price", $$v)
                                            },
                                            expression: "scope.row.price",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1007823174
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("售价")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "成本价", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入成本价",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.costPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "costPrice",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.costPrice",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2169577535
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "sku编码",
                              width: "150",
                              prop: "skuCode",
                            },
                          }),
                          _vm._v(" "),
                          _vm.showBarCodeField
                            ? _c("el-table-column", {
                                attrs: { label: "商品条码", width: "160" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "请输入商品条码",
                                            },
                                            model: {
                                              value: scope.row.barCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "barCode",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.barCode",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1307621386
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请输入库存",
                                            type: "number",
                                            min: "0",
                                          },
                                          on: { input: _vm.handleNumberInput },
                                          model: {
                                            value: scope.row.stock,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "stock", $$v)
                                            },
                                            expression: "scope.row.stock",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                846504313
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("库存")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "库存预警", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入预警值",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.stockWarning,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "stockWarning",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.stockWarning",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3910343526
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "起购量", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入起卖量",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: {
                                          input: _vm.handleNumberInput,
                                          blur: function ($event) {
                                            return _vm.validateSkuQuantityRange(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.minQuantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "minQuantity",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.minQuantity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2979569415
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "限购", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入限购量",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: {
                                          input: _vm.handleNumberInput,
                                          blur: function ($event) {
                                            return _vm.validateSkuQuantityRange(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.maxQuantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "maxQuantity",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.maxQuantity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1112611621
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "重量(kg)", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入重量",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.weight,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "weight", $$v)
                                          },
                                          expression: "scope.row.weight",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              875023600
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "长(m)", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入重量",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.volumeLong,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeLong",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeLong",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              968323442
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "宽(m)", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入重量",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.volumeWide,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeWide",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeWide",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2514544007
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "高(m)", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请输入高",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: { input: _vm.handleNumberInput },
                                        model: {
                                          value: scope.row.volumeHigh,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "volumeHigh",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.volumeHigh",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              425371500
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "上下架状态",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": "上架",
                                          "inactive-text": "下架",
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        model: {
                                          value: scope.row.status,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "status", $$v)
                                          },
                                          expression: "scope.row.status",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              297954310
                            ),
                          }),
                          _vm._v(" "),
                          !_vm.isEditMode
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "80",
                                  align: "center",
                                  fixed: "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "delete-btn",
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteSkuCombination(
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                删除\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  358619636
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }